import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { ConditionPhase } from '../models/condition-phases';

@Injectable({
  providedIn: 'root',
})
export class ConditionPhasesEntityService extends BaseEntityService<ConditionPhase> {
  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl,
      { singular: 'conditionPhase', plural: 'conditionPhases', url: 'condition-phases' },
      routerParamsService
    );
    this.nameId = 'conditionPhaseId';
  }
}
